const state = {
    powers: [],
};

const mutations = {
    setPowers(state, value) {
        state.powers = value;
    },
};

const actions = {};

const getters = {
    powers: (state) => state.powers,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
